"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Uploader = void 0;
const uuid_1 = require("uuid");
const Resumable = require('resumablejs');
class Uploader {
    constructor(config = {}, handlers = {}, folderName = 'default') {
        const { errorParser } = config, configuration = __rest(config, ["errorParser"]);
        const resumable = new Resumable(Object.assign({ target: `/app/api/fileuploader/folders/${folderName}/files`, testChunks: false, simultaneousUploads: 1, headers: { 'X-Requested-With': 'XMLHttpRequest' }, permanentErrors: [302, 400, 404, 415, 500, 501], generateUniqueIdentifier: () => uuid_1.v4() }, configuration));
        resumable.on('fileAdded', () => {
            resumable.upload();
        });
        resumable.on('fileProgress', resumableFile => {
            if (resumableFile.isComplete()) {
                return;
            }
            let progress = Math.floor(resumableFile.progress(false) * 100);
            if (progress > 99) {
                progress = 99;
            }
            if (handlers.progress) {
                handlers.progress(resumableFile.file, progress);
            }
        });
        resumable.on('fileSuccess', (resumableFile, message) => {
            if (handlers.success) {
                handlers.success(resumableFile.file, message);
            }
            resumableFile.cancel();
        });
        resumable.on('fileError', (resumableFile, message) => {
            if (handlers.error) {
                handlers.error(resumableFile.file, errorParser ? errorParser(message) : message);
            }
            resumableFile.cancel();
        });
        this.resumable = resumable;
    }
    upload(source) {
        if (source instanceof File) {
            this.resumable.addFile(source);
        }
        else {
            for (const file of Array.from(source)) {
                this.resumable.addFile(file);
            }
        }
    }
    cancel(file) {
        if (file) {
            for (const resumableFile of this.resumable.files) {
                if (resumableFile.file === file) {
                    resumableFile.cancel();
                    break;
                }
            }
        }
        else {
            this.resumable.cancel();
        }
    }
}
exports.Uploader = Uploader;
//# sourceMappingURL=uploader.js.map